import { render, staticRenderFns } from "./PsiFileUpload.vue?vue&type=template&id=0a6f818c&scoped=true&"
import script from "./PsiFileUpload.vue?vue&type=script&lang=js&"
export * from "./PsiFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f818c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6f818c')) {
      api.createRecord('0a6f818c', component.options)
    } else {
      api.reload('0a6f818c', component.options)
    }
    module.hot.accept("./PsiFileUpload.vue?vue&type=template&id=0a6f818c&scoped=true&", function () {
      api.rerender('0a6f818c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/Media/PsiFileUpload.vue"
export default component.exports